













import {
  Component,
  Vue,
} from 'vue-property-decorator';

import bButton from 'bootstrap-vue/es/components/button/button';
import bForm from 'bootstrap-vue/es/components/form/form';
import bInput from 'bootstrap-vue/es/components/form-input/form-input';

@Component({
  components: {
    bButton,
    bForm,
    bInput,
  },
})
export default class PromotionalCodesForm extends Vue { }

